import "./NotFoundPage.css";

export const NotFoundPage = () => {
  return (
    <div>
      Not Found :&#40;
    </div>
  );
}
